import { Dispatch } from 'react';
import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import { handleError } from 'src/contexts/utils/handleError';
import { SET_LOADING } from 'src/contexts/types';
import { TContactActionTypes } from '../types';
import { CREATE_CONTACT } from '../constants/actions';
import { IContact } from 'src/interfaces/contact';

export const createContact = async (
    dispatch: Dispatch<TContactActionTypes>,
    body: Record<string, unknown>
): Promise<Partial<IContact> | undefined> => {
    dispatch({ type: SET_LOADING });

    try {
        const res = await ApiV2.post('/contacts/create', body, HEADERS({
            isReadPermissionNecessary: false,
        }));
        dispatch({
            type: CREATE_CONTACT,
            payload: res.data.data,
        });
        return res.data.data;
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
    }
};
